const approveAssignmentErrors = [
  'ID NO VALIDO',
  'SOLICITUD EN ESTADO NO VALIDO PARA APROBAR',
  'Error al Aceptar Asignación - Wallet solicitante Pendiente de Habilitacion',
  'Error al Aceptar Asignación',
  'ID NO ENCONTRADO',
]
export const approveAssignmentErrorsUpper = approveAssignmentErrors.map(
  (element) => element.toUpperCase(),
)
const denyAssignmentErrors = [
  'ID NO VALIDO',
  'SOLICITUD EN ESTADO NO VALIDO PARA RECHAZAR',
  'Error al rechazar Enrolamiento en Amired',
  'Error al rechazar Enrolamiento',
  'ID NO ENCONTRADO',
]
export const denyAssignmentErrorsUpper = denyAssignmentErrors.map((element) =>
  element.toUpperCase(),
)

const denyReassignErrors = [
  'ID NO VALIDO',
  'SOLICITUD EN ESTADO NO VALIDO PARA RECHAZAR',
  'Error al rechazar Reasignación',
  'ID NO ENCONTRADO',
]
export const denyReassignErrorsUpper = denyReassignErrors.map((element) =>
  element.toUpperCase(),
)
const approveReassignErrors = [
  'ID NO VALIDO',
  'SOLICITUD EN ESTADO NO VALIDO PARA APROBAR',
  'Error al Aceptar Reasignación - Wallet solicitante Pendiente de Habilitacion',
  'Error al Aceptar Reasignación - ERROR al Desenrolar Wallet Anterior',
  'Error al Aceptar Reasignación',
  'ID NO ENCONTRADO',
]
export const approveReassignErrorsUpper = approveReassignErrors.map((element) =>
  element.toUpperCase(),
)
